import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
    ],
    default_value: 'reviews',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Product Reviews Atom Module
 */
export class GpProductReviews extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Product Reviews';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'product-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
